const faCamera = {
  prefix: 'fal',
  iconName: 'camera',
  icon: [
    512,
    512,
    [62258, 'camera-alt'],
    'f030',
    'M186.4 32c-17.1 0-32.9 9.1-41.5 23.8L121.5 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-57.5 0-23.4-40.2C358.5 41.1 342.7 32 325.6 32L186.4 32zM172.6 71.9c2.9-4.9 8.1-7.9 13.8-7.9l139.2 0c5.7 0 11 3 13.8 7.9l28.1 48.1c2.9 4.9 8.1 7.9 13.8 7.9l66.7 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l66.7 0c5.7 0 11-3 13.8-7.9l28.1-48.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z',
  ],
};
export default faCamera;
